<template>
  <footer class="home-footer">
    <section class="footer-inner">
      <div>
        <img
          class="img-logo"
          src="@/assets/img/images/home/logo-h.png"
          alt="logo"
        />
        <div class="">
          <img
            class="img-item"
            src="@/assets/img/images/home/footer1.png"
            alt="footer1"
            @click="
              goWebsite(
                'https://x.com/rwa_ltd?s=21&t=WsNz_1-HI8IWwAiYKqi0qg',
                '_blank',
              )
            "
          />
          <img
            class="img-item"
            src="@/assets/img/images/home/footer2.png"
            alt="footer2"
            @click="goWebsite('https://medium.com/@rwa-ltd', '_blank')"
          />
          <img
            class="img-item"
            src="@/assets/img/images/home/footer3.png"
            alt="footer3"
            @click="goWebsite('https://t.me/hkrwac', '_blank')"
          />
          <img
            class="img-item"
            src="@/assets/img/images/home/footer4.png"
            alt="footer4"
            @click="goWebsite('mailto:s@rwa.ltd', '_blank')"
          />
          <img
            class="img-item"
            src="@/assets/img/images/home/footer5.png"
            alt="footer5"
            @click="
              goWebsite(
                'https://www.instagram.com/p/DY50Tmhzf1w/?igsh=bTloeXpocjJoZnQx',
                '_blank',
              )
            "
          />
        </div>
      </div>
      <div class="footer-title-box">
        <div class="footer-title">
          <div>{{ $t("home.footer.about") }}</div>
          <p @click="$router.push({ path: '/footerAbout' })">
            {{ $t("home.footer.about") }}
          </p>
          <el-popover placement="top" trigger="hover">
            <p>{{ $t("home.footer.emailAddress") }}：s@rwa.ltd</p>
            <p slot="reference">{{ $t("home.footer.contact") }}</p>
          </el-popover>
          <p
            @click="
              goWebsite('https://maps.app.goo.gl/aACCTM7MGAvWzhd87', '_blank')
            "
          >
            {{ $t("home.footer.companyaddress") }}
          </p>
          <p @click="$router.push({ path: '/question' })">
            {{ $t("home.footer.questions") }}
          </p>
        </div>
        <div class="footer-title">
          <div>{{ $t("home.footer.legal") }}</div>
          <p @click="$router.push({ path: '/footerAgreement' })">
            {{ $t("home.footer.terms") }}
          </p>
          <p @click="$router.push({ path: '/footerBuyProtocol' })">
            {{ $t("home.footer.buyProtocol") }}
          </p>
          <p @click="$router.push({ path: '/footerPrivacy' })">
            {{ $t("home.footer.privacy") }}
          </p>
        </div>
        <div class="footer-title">
          <div>{{ $t("home.footer.ecosystem") }}</div>
          <!-- <p>Genius Coffee</p> -->
          <p @click="$router.push({ path: '/download' })">
            {{ $t("home.footer.rwaApp") }}
          </p>
        </div>
      </div>
    </section>
    <aside class="copy mt60">
      © Copyright 2025 - 2026. All rights reserved. RWA Group Limited and its
      affiliated entities.
    </aside>
    <aside class="copy mt12">
      All images displayed on this website or Apps are provided for
      informational purposes only and may not represent the final design,
      appearance or graphics of the relevant products.
    </aside>
    <aside class="copy1 mt24" @click="introductionFlag = !introductionFlag">
      Legal & Risk Disclosure
      <i v-if="!introductionFlag" class="el-icon-arrow-down" />
      <i v-if="introductionFlag" class="el-icon-arrow-up" />
    </aside>
    <transition name="legal-disclosure">
      <aside class="copy2 mt24" v-show="introductionFlag">
        <p class="mb24">
          The consumer tokens circulating on RWA.LTD (the “Consumer Tokens”) are
          intended solely to provide consumers with access to consumable goods and
          services offered by the relevant issuers acting as merchants. The
          Consumer Tokens are not, and are not intended to constitute, securities,
          investment contracts, financial instruments or any other form of
          regulated financial product.
        </p>
        <p>
          The Consumer Tokens have been designed and designated as a means of
          facilitating the sale and purchase of consumable goods and services and
          are intended to fall outside the definition of “Virtual Asset” under
          section 53ZRA of the Anti-Money Laundering and Counter-Terrorist
          Financing Ordinance (the “AMLO”) of Hong Kong. This is because the
          Consumer Tokens do not constitute payment tokens or governance tokens
          and therefore do not fall within the statutory definition of a “Virtual
          Asset”. Even if any Consumer Token were otherwise capable of falling
          within that definition, it is intended to fall within the definition of
          a “Limited Purpose Digital Token” under section 53ZR of the AMLO and,
          accordingly, to be excluded from the definition of “Virtual Asset”.
        </p>
        <p>
          RWA Group Limited, a company registered in Hong Kong under Business
          Registration Number 74645397, is the operator of RWA.LTD. No licence or
          permit related to securities or Virtual Assets is required for RWA Group
          Limited in connection with the operation of RWA.LTD on the basis that
          the Consumer Tokens are neither securities nor Virtual Assets. RWA.LTD
          is not a Virtual Asset Trading Platform (“VATP”) under the laws of Hong
          Kong.
        </p>
        <p>
          Before engaging in any activities involving crypto assets, including the
          Consumer Tokens and other types of crypto assets, you should carefully
          consider the following risks and matters: (a) the value of crypto assets
          may fluctuate significantly, which may result in substantial or total
          losses; (b) the regulatory treatment of crypto assets may vary between
          jurisdictions, and applicable laws, regulations and regulatory
          interpretations may change over time, potentially affecting your rights
          and obligations; (c) you may be subject to taxes or other fiscal
          obligations in respect of profits or gains arising from the sale or
          disposal of crypto assets; and (d) the utilities, goods or services
          associated with the crypto assets may become unavailable or may not be
          redeemable from the relevant issuer and/or its affiliates in the event
          of the failure, suspension, discontinuation or cessation of their
          businesses, including businesses relating to the relevant consumer goods
          and services or crypto projects.
        </p>
        <p>
          WINPOINT and 穩點 are registered in Hong Kong SAR and other
          jurisdictions.
        </p>
      </aside>
    </transition>
  </footer>
</template>

<script>
export default {
  name: "v-footer",
  data() {
    return { introductionFlag: false };
  },
  methods: {
    goWebsite(url, win) {
      if (win == "_blank") {
        window.open(url, win);
      } else {
        window.location.href = url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-footer {
  width: 100%;
  // height: 491px;
  padding-bottom: 44px;
  background: #f7f6f4;
  .footer-inner {
    display: flex;
    padding: 0 60px;
    justify-content: center;
    .img-logo {
      width: 156px;
      height: 42px;
      margin-top: 120px;
    }
    .img-item {
      width: 45px;
      height: 45px;
      margin-top: 60px;
      margin-right: 40px;
    }
  }
  .footer-title-box {
    flex: 1;
    display: flex;
    margin-top: 120px;
    justify-content: space-evenly;
    .footer-title {
      div {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #333333;
        margin-bottom: 44px;
      }
      p {
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #999999;
        margin-bottom: 20px;
      }
    }
  }
  .copy {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }
  .copy1 {
    cursor: pointer;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    margin-left: 60px;
    margin-right: 60px;
    i {
      margin-left: 10px;
    }
  }
  .copy2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    text-align: center;
    padding-top: 24px;
    padding-left: 60px;
    padding-right: 60px;
    overflow: hidden;
    border-top: 1px solid rgba(112, 112, 112, 0.2);
    p {
      margin-bottom: 24px;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }

  .legal-disclosure-enter-active,
  .legal-disclosure-leave-active {
    transition: all 0.35s ease;
  }

  .legal-disclosure-enter,
  .legal-disclosure-leave-to {
    opacity: 0;
    max-height: 0;
    transform: translateY(-8px);
  }

  .legal-disclosure-enter-to,
  .legal-disclosure-leave {
    opacity: 1;
    max-height: 1200px;
    transform: translateY(0);
  }
}
</style>
